import CommonHttp from '../common/Http'
import { httpHost, HttpMethod } from '../config/http.config'
import { setToken } from '../context/authorization'
import { gotoError103, gotoError106 } from '../router'
import HttpResult from './HttpResult'
import { createHeader, createParams, getToken } from './parameter'

/** */
export default class Http extends CommonHttp {
  /**对应data */
  param2

  header = {
    'content-type': 'application/json'
  }

  constructor(obj) {
    super(obj)
    this.param2 = obj.param2
    this.url = this.url.replace(/^\//, '')
    if (this.host || this.host === '') {
      this.url = this.host + this.url
    } else {
      this.url = httpHost + this.url
    }
  }

  /**
   * 重载父类方法 解决已知异常
   * @返回值'check-true' 校验通过
   * @返回值'check-false' 校验未通过 需要终止程序
   * @返回值'check-false-continue' 校验未通过 程序继续执行
   * @返回值 重发http后的返回值
   */
  async solveError(res) {
    //console.log('solveError', res)
    // 103Token过期
    if (res.Code === 103 || res.ErrorCode === 103) {
      if (this.checkReloadCount()) {
        setToken() // 清除token
        const token = await getToken() // 重新获取token
        if (!token) return 'check-false-continue'
        this.header = await createHeader(this) // 重新签名
        const data = await this.reload()
        return data
      } else {
        gotoError103()
      }
    } else if (res.Code === 106 || res.ErrorCode === 106) {
      // 106用户未登录
      setToken() // 清除token
      // 跳转页面、
      gotoError106()
    }
    return 'check-true'
  }

  /**
   * 发起get请求 需要登录
   * @returns
   */
  async get() {
    this.data = await createParams(this.param2)
    this.header = await createHeader(this)
    this.method = HttpMethod.GET
    this.cacheUserStr = this.header.sisscloudtokenid
    return new HttpResult(await this.request())
  }

  /**
   * 发起post请求
   * @returns
   */
  async post() {
    this.data = await createParams(this.param2)
    this.header = await createHeader(this)
    this.method = HttpMethod.POST
    this.cacheUserStr = this.header.sisscloudtokenid
    return new HttpResult(await this.request())
  }

  async download() {
    this.data = await createParams(this.param2)
    this.header = await createHeader(this)
    this.method = HttpMethod.POST
    this.responseType = 'arraybuffer'
    this.timeout = 60000
    this.isCache = false
    return new HttpResult(await this.request(), true)
  }

  async postForm() {
    this.data = this.param2
    this.header = await createHeader(this)
    this.method = HttpMethod.POST
    this.timeout = 60000
    this.isCache = false
    return new HttpResult(await this.request())
  }
}
